module.exports = __webpack_public_path__ + "static/img/7.6d3de76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/7.png
// module id = Hkfo
// module chunks = 0